import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-huong-dan-su-dung',
  templateUrl: './huong-dan-su-dung.component.html',
  styleUrls: ['./huong-dan-su-dung.component.css']
})
export class HuongDanSuDungComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
